import { PostRequest } from "../../utils/ApiServices";

export const apiGetWebinar = async (postData) => {
  return await PostRequest(`get-webinar-details`, postData);
};
